import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

export default function EmptyState({ title, message, icon, action }) {
  return (
    <Paper sx={{ p: 3, textAlign: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
        {icon}
        {title && <Typography variant="h6">{title}</Typography>}
        {message && <Typography variant="body2" color="text.secondary">{message}</Typography>}
        {action}
      </Box>
    </Paper>
  );
}

